// Get Shopify Variant Stock
export const GET_SHOPIFY_VARIANT_STOCK_REQUEST = 'GET_SHOPIFY_VARIANT_STOCK_REQUEST';
export const GET_SHOPIFY_VARIANT_STOCK_DONE = 'GET_SHOPIFY_VARIANT_STOCK_DONE';
export const GET_SHOPIFY_VARIANT_STOCK_FAILED = 'GET_SHOPIFY_VARIANT_STOCK_FAILED';
export const GET_SHOPIFY_VARIANT_STOCK_RESET = 'GET_SHOPIFY_VARIANT_STOCK_RESET';
